import {
  API_URL_ADMIN_CREATE_EXISTING_USER,
  API_URL_ADMIN_CREATE_USER_MANAGEMENT,
  API_URL_ADMIN_DELETE_WB_USER_MANAGEMENT,
  API_URL_ADMIN_GET_USER_COUNTS_BY_ROLE,
  API_URL_ADMIN_GET_USER_MANAGEMENT_DETAIL,
  API_URL_ADMIN_GET_USER_MANAGEMENT_LIST,
  API_URL_ADMIN_GET_WB_OTHER_MODULE_USER_LIST,
  API_URL_ADMIN_UPDATE_USER_MANAGEMENT,
  API_URL_ADMIN_GET_ASSIGN_ANALYST_LIST,
  API_URL_ADMIN_UPLOAD_USERS_CSV,
  CM_API_URL_ADMIN_CREATE_EXISTING_USER,
  CM_API_URL_ADMIN_CREATE_USER_MANAGEMENT,
  CM_API_URL_ADMIN_DELETE_WB_USER_MANAGEMENT,
  CM_API_URL_ADMIN_GET_USER_COUNTS_BY_ROLE,
  CM_API_URL_ADMIN_GET_USER_MANAGEMENT_DETAIL,
  CM_API_URL_ADMIN_GET_USER_MANAGEMENT_LIST,
  CM_API_URL_ADMIN_GET_WB_OTHER_MODULE_USER_LIST,
  CM_API_URL_ADMIN_UPDATE_USER_MANAGEMENT,
  CM_USER_MANAGEMENT_URL,
  CM_API_URL_ADMIN_GET_ASSIGN_ANALYST_LIST,
  CM_API_URL_ADMIN_UPLOAD_USERS_CSV,
  API_BASE_URL as WB_BASE_URL,
  API_URL_ADMIN_DELETE_AND_REPLACE_WB_USER_MANAGEMENT,
  CM_API_URL_ADMIN_DELETE_AND_REPLACE_USER_MANAGEMENT
} from "src/common/constants";
import {
  API_TPDD_USER_MANAGAMEN_BASE_URL,
  API_URL_ADMIN_CREATE_TPDD_EXISTING_USER,
  API_URL_ADMIN_CREATE_TPDD_USER_MANAGEMENT,
  API_URL_ADMIN_DELETE_TPDD_USER_MANAGEMENT,
  API_URL_ADMIN_GET_TPDD_OTHER_MODULE_USER_LIST,
  API_URL_ADMIN_GET_TPDD_USER_COUNTS_BY_ROLE,
  API_URL_ADMIN_GET_TPDD_USER_MANAGEMENT_LIST,
  API_URL_ADMIN_GET_USER_MANAGEMENT_DETAIL as TPDD_API_URL_ADMIN_GET_USER_MANAGEMENT_DETAIL,
  API_URL_ADMIN_UPDATE_USER_MANAGEMENT as TPDD_API_URL_ADMIN_UPDATE_USER_MANAGEMENT,
  API_BASE_URL as TPDD_BASE_URL,
  API_URL_ADMIN_GET_ASSIGN_ANALYST_LIST as API_URL_ADMIN_GET_TPDD_ASSIGN_ANALYST_LIST,
  API_URL_ADMIN_DELETE_AND_REPLACE_TPDD_USER_MANAGEMENT,
  API_URL_ADMIN_UPLOAD_USERS_CSV as TPDD_API_URL_ADMIN_UPLOAD_USERS_CSV
} from "src/modules/3rd-party-management/constants";
import {
  API_BASE_URL,
  API_URL_ADMIN_DELETE_GDPR_USER_MANAGEMENT,
  API_URL_ADMIN_GET_GDPR_USER_MANAGEMENT_LIST,
  API_URL_ADMIN_GET_GDPR_OTHER_MODULE_USER_LIST,
  API_URL_ADMIN_GET_GDPR_USER_MANAGEMENT_DETAIL,
  API_URL_ADMIN_CREATE_GDPR_USER_MANAGEMENT,
  API_URL_ADMIN_UPDATE_GDPR_USER_MANAGEMENT,
  API_URL_ADMIN_GET_GPDR_USER_COUNTS_BY_ROLE,
  API_URL_ADMIN_CREATE_GDPR_EXISTING_USER,
  API_URL_ADMIN_GET_ASSIGN_ANALYST_LIST as API_URL_ADMIN_GET_GDPR_ASSIGN_ANALYST_LIST,
  API_URL_ADMIN_DELETE_AND_REPLACE_GDPR_USER_MANAGEMENT,
  API_URL_ADMIN_UPLOAD_USERS_CSV as GDPR_API_URL_ADMIN_UPLOAD_USERS_CSV
} from "src/modules/data-protection/constants";

export const getUrls = () => ({
  gd: {
    fetchUsers: API_URL_ADMIN_GET_GDPR_USER_MANAGEMENT_LIST,
    fetchOtherUsers: API_URL_ADMIN_GET_GDPR_OTHER_MODULE_USER_LIST,
    deleteUser: API_URL_ADMIN_DELETE_GDPR_USER_MANAGEMENT,
    deleteAndReplaceUser: API_URL_ADMIN_DELETE_AND_REPLACE_GDPR_USER_MANAGEMENT,
    baseUrl: API_BASE_URL,
    createNewUser: API_URL_ADMIN_CREATE_GDPR_USER_MANAGEMENT,
    createNewExistingUser: API_URL_ADMIN_CREATE_GDPR_EXISTING_USER,
    fetchUserCounts: API_URL_ADMIN_GET_GPDR_USER_COUNTS_BY_ROLE,
    getUserDetails: API_URL_ADMIN_GET_GDPR_USER_MANAGEMENT_DETAIL,
    editUser: API_URL_ADMIN_UPDATE_GDPR_USER_MANAGEMENT,
    fetchAnalystAndAdminAnalysts: API_URL_ADMIN_GET_GDPR_ASSIGN_ANALYST_LIST,
    uploadCSV: GDPR_API_URL_ADMIN_UPLOAD_USERS_CSV
  },
  wb: {
    fetchUsers: API_URL_ADMIN_GET_USER_MANAGEMENT_LIST,
    fetchOtherUsers: API_URL_ADMIN_GET_WB_OTHER_MODULE_USER_LIST,
    deleteUser: API_URL_ADMIN_DELETE_WB_USER_MANAGEMENT,
    deleteAndReplaceUser: API_URL_ADMIN_DELETE_AND_REPLACE_WB_USER_MANAGEMENT,
    baseUrl: WB_BASE_URL,
    createNewUser: API_URL_ADMIN_CREATE_USER_MANAGEMENT,
    createNewExistingUser: API_URL_ADMIN_CREATE_EXISTING_USER,
    fetchUserCounts: API_URL_ADMIN_GET_USER_COUNTS_BY_ROLE,
    getUserDetails: API_URL_ADMIN_GET_USER_MANAGEMENT_DETAIL,
    editUser: API_URL_ADMIN_UPDATE_USER_MANAGEMENT,
    fetchAnalystAndAdminAnalysts: API_URL_ADMIN_GET_ASSIGN_ANALYST_LIST,
    uploadCSV: API_URL_ADMIN_UPLOAD_USERS_CSV
  },
  cm: {
    fetchUsers: CM_API_URL_ADMIN_GET_USER_MANAGEMENT_LIST,
    fetchOtherUsers: CM_API_URL_ADMIN_GET_WB_OTHER_MODULE_USER_LIST,
    deleteUser: CM_API_URL_ADMIN_DELETE_WB_USER_MANAGEMENT,
    deleteAndReplaceUser: CM_API_URL_ADMIN_DELETE_AND_REPLACE_USER_MANAGEMENT,
    baseUrl: CM_USER_MANAGEMENT_URL,
    createNewUser: CM_API_URL_ADMIN_CREATE_USER_MANAGEMENT,
    createNewExistingUser: CM_API_URL_ADMIN_CREATE_EXISTING_USER,
    fetchUserCounts: CM_API_URL_ADMIN_GET_USER_COUNTS_BY_ROLE,
    getUserDetails: CM_API_URL_ADMIN_GET_USER_MANAGEMENT_DETAIL,
    editUser: CM_API_URL_ADMIN_UPDATE_USER_MANAGEMENT,
    fetchAnalystAndAdminAnalysts: CM_API_URL_ADMIN_GET_ASSIGN_ANALYST_LIST,
    uploadCSV: CM_API_URL_ADMIN_UPLOAD_USERS_CSV
  },
  tp: {
    fetchUsers: API_URL_ADMIN_GET_TPDD_USER_MANAGEMENT_LIST,
    fetchOtherUsers: API_URL_ADMIN_GET_TPDD_OTHER_MODULE_USER_LIST,
    deleteUser: API_URL_ADMIN_DELETE_TPDD_USER_MANAGEMENT,
    deleteAndReplaceUser: API_URL_ADMIN_DELETE_AND_REPLACE_TPDD_USER_MANAGEMENT,
    baseUrl: API_TPDD_USER_MANAGAMEN_BASE_URL,
    createNewUser: API_URL_ADMIN_CREATE_TPDD_USER_MANAGEMENT,
    createNewExistingUser: API_URL_ADMIN_CREATE_TPDD_EXISTING_USER,
    fetchUserCounts: API_URL_ADMIN_GET_TPDD_USER_COUNTS_BY_ROLE,
    getUserDetails: TPDD_API_URL_ADMIN_GET_USER_MANAGEMENT_DETAIL,
    editUser: TPDD_API_URL_ADMIN_UPDATE_USER_MANAGEMENT,
    fetchAnalystAndAdminAnalysts: API_URL_ADMIN_GET_TPDD_ASSIGN_ANALYST_LIST,
    uploadCSV: TPDD_API_URL_ADMIN_UPLOAD_USERS_CSV
  },
});

export const routes = {
  gd: {
    newUser: "/admin/data-protection/administration/users/add",
    listOfUsers: "/admin/data-protection/administration/users",
    editUser: (id) => `/admin/data-protection/administration/users/${id}/edit`,
  },
  tp: {
    newUser: "/admin/3rd-party/administration/users/add",
    listOfUsers: "/admin/3rd-party/administration/users",
    editUser: (id) => `/admin/3rd-party/administration/users/${id}/edit`,
  },
  wb: {
    newUser: "/admin/administration/users/add",
    listOfUsers: "/admin/administration/users",
    editUser: (id) => `/admin/administration/users/${id}/edit`,
  },
  cm: {
    newUser: "/admin/administration/users/add",
    listOfUsers: "/admin/administration/users",
    editUser: (id) => `/admin/administration/users/${id}/edit`,
  },
};

export const roles = {
  ROLE_ANALYST_ADMIN: {
    label: "Analyst Admin",
    modules: ["wb", "cm", "gd", "tp"]
  },
  ROLE_ANALYST: {
    label: "Analyst",
    modules: ["wb", "cm", "gd", "tp"]
  },
  ROLE_EMPLOYEE: {
    label: "Employee",
    modules: ["wb", "cm", "gd"]
  },
  ROLE_TASK_OWNER: {
    label: "Task Owner",
    modules: ["wb", "cm", "gd"]
  },
};
  
export const validRolesForAnalystAdmin = {
  ROLE_EMPLOYEE: {
    label: "Employee",
    modules: ["wb", "cm", "gd"]
  },
  ROLE_TASK_OWNER: {
    label: "Task Owner",
    modules: ["wb", "cm", "gd"]
  }
};

export default { routes };
